import React from 'react';
import { motion } from 'framer-motion';
import '../css/Nssc.css';

const Nssc = () => {
  document.title = "NSSC | Space Technology Students' Society";

  return (
    <div className="nssc-container">
      <div className="nssc-content-wrapper">

        {/* --- TITLE SECTION --- */}
        <motion.h1
          className="nssc-title"
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div>NATIONAL STUDENTS'</div>
          <div>SPACE CHALLENGE</div>
        </motion.h1>

        {/* --- C-SHAPED BRACKET GRID --- */}
        <div className="nssc-bracket-grid">

          {/* ZONE 1: TOP (Roof) - Spans Full Width */}
          <motion.div
            className="nssc-glass-card nssc-grid-top"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            {/* <h2 className="nssc-subtitle">The Centrepiece of spAts</h2> */}
            <p className="nssc-text">
              The <span className="nssc-highlight">National Students' Space Challenge (NSSC)</span> is the flagship event of spAts, IIT Kharagpur. Established in 2011, NSSC is a national-level fest dedicated exclusively to space science, astronomy, and space technology, bringing together students who share a deep interest in the exploration and advancement of the space domain.
            </p>
          </motion.div>

          {/* ZONE 2: SPINE (Left Wall) - Sits next to Logo */}
          <motion.div
            className="nssc-glass-card nssc-grid-spine"
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <p className="nssc-text">
              Conceived as an independent initiative of the society, NSSC was created to provide a focused platform for aspiring engineers, scientists, and researchers across India to showcase their skills and engage with real-world challenges in aerospace and space-related fields. Over the years, it has evolved into a structured and dynamic forum that promotes innovation, technical excellence, and collaborative learning.
            </p>
            <p className="nssc-text">
              The fest features a diverse range of technical competitions and knowledge-driven events, including autonomous and manual robotics challenges, space quizzes, case studies, rover simulations, and astrophotography contests.
            </p>
          </motion.div>

          {/* ZONE 3: THE HOLLOW (Visual Centerpiece) */}
          <motion.div
            className="nssc-visual-card"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            {/* Gravitational Ripples */}
            <div className="nssc-ripple nssc-ripple-1"></div>
            <div className="nssc-ripple nssc-ripple-2"></div>
            <div className="nssc-ripple nssc-ripple-3"></div>

            {/* Static Logo */}
            <img src="/img/nssc-logo.png" alt="NSSC Logo" className="nssc-logo-img" />
            <p className="nssc-est">EST. 2011</p>
          </motion.div>

          {/* ZONE 4: BOTTOM (Floor) - Spans Full Width */}
          <motion.div
            className="nssc-glass-card nssc-grid-bottom"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.4 }}
          >
            <p className="nssc-text">
              Complementing these events are guest lectures, workshops, and exhibitions conducted by professionals and researchers from the space sector, offering participants exposure to current developments and practical insights into the industry.
            </p>
            <p className="nssc-text">
              As a student-led initiative, NSSC reflects the growing enthusiasm for space science among young minds in India. By fostering curiosity, problem-solving, and hands-on experience, it continues to serve as a meaningful platform for those aspiring to contribute to the future of space exploration and technology.
            </p>
          </motion.div>

        </div>
        {/* --- END GRID --- */}

        {/* --- STATS SECTION --- */}
        <div className="nssc-stats-grid">
          {[
            { val: "13+", label: "Years Running" },
            { val: "150+", label: "Colleges" },
            { val: "13000+", label: "Participants" },
            { val: "10L+", label: "Prizes Worth" }
          ].map((stat, i) => (
            <motion.div
              className="nssc-stat-box"
              key={`${stat.val}-${stat.label}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              whileHover={{
                y: -10,
                rotate: i % 2 === 0 ? -2 : 2,
                backgroundColor: "rgba(255, 255, 255, 0.1)"
              }}
            >
              <h3 className="nssc-stat-value">{stat.val}</h3>
              <p className="nssc-stat-label">{stat.label}</p>
            </motion.div>
          ))}
        </div>

        {/* --- CTA SECTION --- */}
        <div className="nssc-cta-section">
          <a href="https://nssc.in" target="_blank" rel="noopener noreferrer" className="nssc-btn">
            EXPLORE NSSC.IN
          </a>
        </div>

      </div>
    </div>
  );
};

export default Nssc;